(ns frontend.ui.component.nested-dropdown.style)

(defn menu-item
  []
  ^{:pseudo {:hover {:background "rgba(0, 0, 0, 0.02)"}}}
  {:height          "50px"
   :display         "flex"
   :justify-content "space-between"
   :align-items     "center"
   :padding         "10px"
   :cursor          "pointer"})
